module.exports = __webpack_public_path__ + "static/img/circle2.a28b1ff3.png";